<template>
    <div class="width_100 ">
        <div class="pos_rel">
            <img src="./../assets/Sustain_suite_login_page_image.png"
                lazy-src="./../assets/Sustain_suite_login_page_image.png" class="login_bg" />
            <img class="logo_bg" src="./../assets/sustain-suite-logo-gradient.png" />
            <div class="login_card ">
                <div class="w_100 mgn-bt-20 pad_10">
                    <div>
                        <div class="sign_in">Sign in</div>
                    </div>
                    <div>
                        <v-alert v-show="error" type="error" transition="scale-transition">
                            {{ error }}
                        </v-alert>

                        <v-alert v-show="success" type="success" transition="scale-transition">
                            {{ success }}
                        </v-alert>

                        <v-form @keyup.native.enter="submit">
                            <div class="mgn-up-10">
                                <div class="form_field_label">Email address</div>
                                <div>
                                    <!-- :label="$t('common.username') + '*'" autofocus -->
                                    <v-text-field class="custom_text_field" autofocus ref="username"
                                         name="userName" type="text"
                                        v-model="user.userName" :error-messages="usernameErrors"
                                        @input="$v.user.userName.$touch()" @blur="$v.user.userName.$touch()" 
                                        placeholder="Your email address" outlined></v-text-field>
                                </div>
                            </div>
                            <div >
                                <div class="form_field_label">Password</div>
                                <div>
                                    <!-- :label="$t('common.password') + '*'" -->
                                    <v-text-field class="custom_text_field" id="password"
                                         name="password" v-model="user.password"
                                        :type="showPassword ? 'text' : 'password'"
                                        :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                                        @click:append="showPassword = !showPassword" :error-messages="passwordErrors"
                                        @input="$v.user.password.$touch()" @blur="$v.user.password.$touch()"
                                        outlined placeholder="Your password"></v-text-field>
                                </div>
                            </div>
                            <div class="checkbox_reset_bg">
                                <div>
                                    <v-checkbox color="primary" v-model="user.rememberMe"
                                        :label="$t('common.rememberMe')" hide-details
                                        class="checkbox_cls width_100"></v-checkbox>
                                </div>
                                <div class="forget_pass_bg">
                                    <router-link class="caption" :to="{ name: 'requestPasswordReset' }">
                                        {{ $t("join.forgotPasswordLink") }}
                                    </router-link>
                                </div>
                            </div>
                        </v-form>
                        <div class="mgn-up-10">
                            <v-btn class="login-button" :disabled="loading" @click="submit">
                                <div class="btn_txt_bg">
                                    <div class="login_txt"> {{ $t("common.login") }}</div>
                                    <img class="arrow_bg" src="../assets/arrow.png" />
                                </div>
                            </v-btn>
                        </div>
                    </div>
                </div>
                <div class="right_sub_card">
                    <div class="right_pos">
                        <div class="susuite_txt">Sustain-Suite</div>
                        <div class="susuite_txt_subLanel">Your partner in sustainable growth</div>
                        <div class=" mgn-up-20">
                            <a class="susuite_txt_subLanel_link" href="https://sustain-suite.com/" target="_blank">Learn More</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { required, minLength, maxLength, email } from 'vuelidate/lib/validators'

export default {
    name: 'Login',

    validations: {
        user: {
            userName: {
                required
            },
            password: {
                required
            }
        }
    },

    data: () => ({
        error: null,
        success: null,
        loading: false,

        context: '',

        user: {
            userName: '',
            password: '',
            rememberMe: true
        },
        showPassword: false,
    }),
    computed: {
        usernameErrors() {
            const errors = []

            if (!this.$v.user.userName.$dirty) {
                return errors
            }

            !this.$v.user.userName.required && errors.push(this.$t('common.errors.fieldRequired'))
            return errors
        },
        passwordErrors() {
            const errors = []

            if (!this.$v.user.password.$dirty) {
                return errors
            }

            !this.$v.user.password.required && errors.push(this.$t('common.errors.fieldRequired'))

            return errors
        },
    },
    created() {
        this.$store.dispatch('isLoggedIn').then((responseData) => {
            if (responseData.success === true && responseData.result !== false && responseData.result.user) {
                this.forwardToSharesuite();
            }
        });

        const email = this.$route.query.user;
        if (typeof email !== 'undefined') {
            this.user.userName = email;
        }
    },
    methods: {
        forwardToSharesuite(defCtxId) {
          // Assign default value if defCtxId is null or undefined
      if (defCtxId == null) {
        defCtxId = 1;
      }

            let targetHash = `#m=core:a=ssuite-dashboard-plugin:view=ssuite-dashboard-plugin:ctxId=${defCtxId}`;
            let host = location.protocol + "//" + location.hostname + (location.hostname.endsWith("/") ? "" : "/");
            let newUrl = host + process.env.VUE_APP_WEB_APP_PATH + targetHash;
            location.replace(newUrl);
        },
        submit() {
            this.$v.$touch()
            if (!this.$v.$invalid) {
                this.loading = true;
                this.error = null;
                this.success = null;

                this.$store.dispatch('login', {
                    user: this.user
                }).then((responseData) => {
                    if (responseData.success === true && responseData.result !== false && responseData.result.user) {                    
                    const defCtxId = responseData.result.user.defCtxId;
                    this.forwardToSharesuite(defCtxId);
                    //  this.forwardToSharesuite();
                    } else {
                        this.error = this.$t('join.errors.loginFailed');
                    }
                }).catch((response) => {
                    const errorId = response.data.result.errorId;
                    switch (response.data.result.appId) {
                        // system
                        case 0:
                            switch (errorId) {
                                // already logged in
                                case 11:
                                    this.forwardToSharesuite();
                                    break;
                                default:
                                    this.error = this.$t('join.errors.loginFailed');
                                    break;
                            }
                            break;
                        // core
                        case 1:
                            switch (errorId) {
                                case 7:
                                    this.error = this.$t("login.failedUserLocked");
                                    break;
                                case 13:
                                    this.error = this.$t('join.errors.noContextAvailable');
                                    break;
                                default:
                                    this.error = this.$t('join.errors.loginFailed');
                                    break;
                            }
                            break;
                        default:
                            this.error = this.$t('join.errors.loginFailed');
                            break;
                    }
                }).finally(() => {
                    this.loading = false;
                })
            }
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
* {
    box-sizing: border-box;
    font-family: 'Inter', sans-serif;
}
.login_bg{
    /* height: 100vh; */
    height: calc(100vh - 7px);
    width: 100vw;
    background: linear-gradient(0deg, #D9D9D9 14.5%, #737373 100%);
    background-blend-mode: multiply;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
}
.logo_bg{
    position: absolute;
    top: 13%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 350px;
    background: rgba(255, 255, 255, 0.8);
    padding: 15px;
    border-radius: 60px;
}
.pos_rel{
    position: relative;
}
.pos_abs{
    position: absolute;
}
.login_card{
  
    position: absolute;
    top: 55%;
    left: 50%;
    transform: translate(-50%, -50%);
    box-shadow: 0px 1px 2px 0px #00000014;
    border-radius: 8px;
    background: #FFFFFFCC;
    padding: 10px;
    width: -webkit-fill-available;


    display: flex;
    justify-content: center;
    gap: 10px;
}
.sign_in{
    font-size: 24px;
    font-weight: 600;
    line-height: 29.05px;
    padding: 15px;
    text-align: left;
    color: #202020;
}
.form_field_label{
    font-size: 14px;
    font-weight: 500;
    line-height: 16.94px;
    text-align: left;
    margin-bottom: 10px;
   
}
::v-deep .v-application .success--text{
    color: #1e5799;
}
 ::v-deep .v-application--is-ltr .v-text-field--outlined fieldset{
    border: 1px solid #DCDCDC !important;
    background: #FFFFFF !important;
    border-radius: 8px !important;
}
::v-deep .form_field_label{
font-size: 14px!important;
font-weight: 500!important;
line-height: 16.94px!important;
text-align: left!important;
}
::v-deep .v-text-field--outlined > .v-input__control > .v-input__slot{
    background: #FFFFFF !important;
}
::v-deep.v-input input{
    font-size: 16px !important;
    font-weight: 400 !important;
    line-height: 16.94px !important;
    text-align: left !important;
    color: #000000 !important;
}
::v-deep .v-text-field--outlined fieldset{
    border: none !important;
}

.forget_pass_bg{
    text-align: left;
}

.v-application a {
    color: #464646 !important;
    font-weight: 400 !important;
    text-decoration: none !important;
}
.checkbox_reset_bg{
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.mgn-up-10{
    margin-top: 10px;
}
.mgn-up-20{
    margin-top: 20px;
}
.pad_5{
padding: 5px;
}
.mgn-bt-20{
    margin-bottom: 20px;
}
.pad_10{
    padding: 10px;
}
.login-button {
    background: linear-gradient(90.45deg, #1e5799 8.15%, #7db9e8 135.91%);
    width: 100%;
    outline: none;
    border: none;
}
.login_txt{
   
font-size: 12px;
font-weight: 600;
line-height: 16.94px;
text-align: center;
color: #fff;

}
.btn_txt_bg{
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: space-between;
}
::v-deep  .checkbox_cls .v-label{
    color: #464646 !important;
    font-weight: 400 !important;
    font-size: 14px !important;
}
.arrow_bg{
    height: 15px;
    width: 15px;
}
::v-deep .v-input--selection-controls{
   margin: 0 !important;
   padding: 0 !important;
}
.w_100{
    width: 100%;
}
.right_sub_card{
    width: 45%;
    margin-right: 15px;
    margin-top: -10px;
    margin-bottom: 30px;
    background: rgb(30 87 153 / 50%);
}
.susuite_txt{font-size: 20px;
    font-weight: 800;
    line-height: 24px;
    text-align: center;
    color: #fff;
   }

.susuite_txt_subLanel{
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;
    text-align: center;
    color: #fff;
    margin-top: 10px
}
.susuite_txt_subLanel_link{
    font-size: 16px;
    font-weight: 500 !important;
    line-height: 19.2px;
    text-align: center;
    color: #363636 !important;
    border-bottom: 1px solid #363636;
}
.right_pos{
    position: absolute;
    top: 50%;
    /* left: 67%; */
    width: 190px;
    text-align: center;
}
.right_pos a{
    color: #fff;
}
body,html {
    margin: 0;
    padding: 0;
}
* {
    box-sizing: border-box;
}
.pos_rel:before {
    content: '';
    background: linear-gradient(to bottom, rgba(30, 87, 153, 0.5), rgba(41, 137, 216, 0.4), rgba(32, 124, 202, 0.3), rgba(125, 185, 232, 0.1));
    position: absolute;
    width: 100%;
    height: 100%;
}












































/* .login-button {
    width: 100%;
    text-transform: initial;
    background-color: #022c22 !important;
    width: 25%;
    height: 40px;
    color: #fff;
    margin-top: 20px;

}

.v-card__text {
    padding-bottom: 0 !important;
}

.header-image-container {
    height: 75px;
}

.background-column {
    padding: 0;
}

.background-image {
    height: 100%;
    width: 100%;
    background-image: url(./../assets/graphic_Side.png);

}

.sign_in_btn {
    color: #000000;
    font-size: 25px;
    font-weight: 600
}

.stay_connect {
    color: #8a92a6;
    font-size: 16px;
    font-weight: 400;
    margin-top: 25px;
    margin-bottom: 20px;
}

.checkbox_cls {
    margin-top: 0px;
    padding: 0;
}

.v-application a.caption {
    text-decoration: none;
}

.width_100 {
    width: 100% !important;
}

.remember_div {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
}

.v-label {
    color: #8a92a6
}



.login_bg {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 30px;
}

.mgn-up-30 {
    margin-top: 30px !important;
}

.width_70 {
    width: 70%
}

.pad_10 {
    padding: 10px;
}



.pad_90 {
    padding: 120px;
} */
















.text_end {
    text-align: end;
}
</style>
